import { getSuffixIsImageType } from './util.js';

export default {
    table: {
        height: 300,
        columns: [
            {
                label: '序号',
                prop: 'id',
                sort: true,
                width: 120
            },
            {
                label: '名称',
                prop: 'name',
                sort: true,
                width: 240
            },
            {
                label: '状态',
                prop: 'statusName',
                sort: true,
                width: 120
            },
            {
                label: '生成方式',
                prop: 'createWayName',
                sort: true,
                width: 150
            },
            {
                label: '附件类型',
                prop: 'type',
                sort: true,
                width: 100
            },
            {
                label: '大小(KB)',
                sort: true,
                prop: 'fileSize',
                width: 100
            },
            {
                label: '类型',
                sort: true,
                prop: 'objTypeName',
                width: 120
            },
            {
                label: '创建人',
                sort: true,
                prop: 'createUserName',
                width: 120
            },
            {
                label: '创建时间',
                sort: true,
                prop: 'createTime',
                width: 160
            },
            {
                label: '更新人',
                prop: 'updateUserName',
                sort: true,
                width: 120
            },
            {
                label: '更新时间',
                prop: 'updateTime',
                sort: true,
                width: 160
            }
        ],
        action: {
            fixedWidth: 150,
            list: [
                {
                    type: 'text',
                    label: '查看影像',
                    size: 'mini',
                    event: 'viewImg',
                    ifHas: '150101029',
                    displayRule: row => {
                        return getSuffixIsImageType(row.type);
                    }
                },
                {
                    type: 'text',
                    label: '下载附件',
                    size: 'mini',
                    event: 'downloadFile',
                    ifHas: '150101030'
                }
                // {
                //     type: 'text',
                //     label: '重推',
                //     size: 'mini',
                //     event: 'retweet',
                //     ifHas: '150101031',
                //     displayRule: row => {
                //         if ([0, 10, 20, 30].includes(+row.dispatchStatus)) {
                //             return true;
                //         } else {
                //             return false;
                //         }
                //     }
                // }
            ]
        }
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [10, 20, 30, 50]
    },
    form: {
        dispatchNo: '',
        shippingType: '',
        actualcarType: '',
        iflowStatusName: '',
        suppliersNameCn: '',
        noCarCarrierName: '',
        tranName: '',
        branchName: '',
        escoCompanyNameCn: '',
        bringBackWay: '',
        remark: '',
        infoCost: ''
    }
};
